const isMobileRowBlank = (mobileBrandId, mobileModelName) => {
  const bEmpty = mobileBrandId == null || mobileBrandId === '';
  const mEmpty = mobileModelName == null || mobileModelName === '';
  return bEmpty && mEmpty;
};

/**
 * รวมค่า mobileBrandId / mobileModelName (และ mobileBrandId2 …) จากฟอร์มเป็น array สำหรับ payload mobiles
 */
export const buildWarrantyMobilesArrayFromFormValues = (values) => {
  const out = [{ mobileBrandId: values.mobileBrandId, mobileModelName: values.mobileModelName }];
  for (let n = 2; n <= 20; n += 1) {
    const b = values[`mobileBrandId${n}`];
    const m = values[`mobileModelName${n}`];
    if (isMobileRowBlank(b, m)) {
      break;
    }
    out.push({ mobileBrandId: b, mobileModelName: m });
  }
  return out;
};

/**
 * PATCH warranty/update: แต่ละรายการคือ { mobileBrandId, mobileModelName }
 * ถ้าแก้จากของเดิมที่มี id ให้ใส่ warrantyMobileId จากฟอร์ม (warrantyMobileId1, warrantyMobileId2 …)
 * รายการใหม่ไม่ต้องใส่ warrantyMobileId; รายการที่ลบออกไม่ส่งใน array
 */
export const buildWarrantyEditMobilesPayload = (values) => {
  const out = [];

  const pushRow = (mobileBrandId, mobileModelName, warrantyMobileIdKey) => {
    if (isMobileRowBlank(mobileBrandId, mobileModelName)) {
      return false;
    }
    const item = { mobileBrandId, mobileModelName };
    const wid = values[warrantyMobileIdKey];
    if (wid != null && wid !== '') {
      const num = Number(wid);
      item.warrantyMobileId = Number.isNaN(num) ? wid : num;
    }
    out.push(item);
    return true;
  };

  pushRow(values.mobileBrandId, values.mobileModelName, 'warrantyMobileId1');
  for (let n = 2; n <= 20; n += 1) {
    const b = values[`mobileBrandId${n}`];
    const m = values[`mobileModelName${n}`];
    if (isMobileRowBlank(b, m)) {
      break;
    }
    pushRow(b, m, `warrantyMobileId${n}`);
  }
  return out;
};
